import { CircularProgress, Typography } from '@material-ui/core'
import { Confirm, FlexHorizontal, LoadMask, Spacer, useToasts } from '@vestaboard/installables'
import { ITemplateMessage, MessageTemplateForm } from '../components/MessageTemplateForm'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

import { Alert } from '@material-ui/lab'
import { Link } from '../../link'
import { tryAsync } from '../../../utils/tryAsync'
import { useDeleteTemplateMessage } from '../hooks/useDeleteTemplateMessage'
import { useGetTemplateMessage } from '../hooks/useGetTemplateMessage'
import { useUpdateTemplateMessage } from '../hooks/useUpdateTemplateMessage'

export const UpdateMessage = () => {
  const params = useParams<{ id: string }>()
  const { data, loading, error } = useGetTemplateMessage(params.id)
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteTemplateMessage, { loading: deleting }] = useDeleteTemplateMessage()
  const [updateTemplateMessage, { loading: saving }] = useUpdateTemplateMessage()
  const { addToast } = useToasts()
  const history = useHistory()

  return (
    <>
      {saving || deleting ? <LoadMask /> : null}
      <Confirm
        title='Delete Template Message? This cannot be undone!'
        handleClose={() => {
          setIsDeleting(false)
        }}
        open={isDeleting}
        handleAccept={async () => {
          const { result } = await tryAsync(() =>
            deleteTemplateMessage({
              variables: {
                input: {
                  id: params.id
                }
              }
            })
          )

          if (result && result.data?.deleteTemplateMessage.__typename === 'TemplateMessageV2') {
            history.push(`/message-templates`)
          } else {
            addToast('There was an error deleting your template message', {
              appearance: 'error',
              autoDismiss: true
            })
          }
        }}
      />
      <FlexHorizontal>
        <Link to='/message-templates'>
          <Typography variant='h4'>Template Messages</Typography>
        </Link>
        <Typography variant='h4'> / Update</Typography>
      </FlexHorizontal>
      <Spacer size='large' />
      {loading ? (
        <CircularProgress />
      ) : error || data?.templateMessage?.__typename === 'TemplateMessageErrorV2' ? (
        <Alert severity='error'>There was an error loading this message</Alert>
      ) : (
        <MessageTemplateForm
          templateMessage={(data?.templateMessage as any) as ITemplateMessage}
          onUpdate={async templateMessage => {
            const { result } = await tryAsync(() =>
              updateTemplateMessage({
                variables: {
                  input: {
                    id: params.id,
                    categoryId: templateMessage.categoryId || '',
                    messageId: templateMessage.message?.id || '',
                    isFeatured: templateMessage.isFeatured || false
                  }
                }
              })
            )

            if (result && result.data?.updateTemplateMessage.__typename === 'TemplateMessageV2') {
              addToast('Your template message has been saved', {
                appearance: 'success',
                autoDismiss: true
              })
            } else {
              console.warn(result)
              addToast('There was an error saving your template message', {
                appearance: 'error'
              })
            }
          }}
          onDelete={() => {
            setIsDeleting(true)
          }}
        />
      )}
    </>
  )
}
